import { BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG } from '../../../utils/biEvents/events/bigQueryEvents';
import {
    CLICKED_POPULAR_SEARCH_TAG,
    CLICKED_BANNER_SEARCH
} from '../../../utils/biEvents/events/mixPanelEvents';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../utils/biEvents';

export const BI_TYPE_TAGS = 'bi_tags';
export const BI_TYPE_SEARCH = 'bi_search';

const reportTagBi = (data) => {
    const mpParams = {name: data.name, order: data.position};
    const bqParams = {
        position: data.position,
        page: {
            element: {
                type: data.type,
                text: data.name
            }
        },
        category: {
            id: data.categoryId,
            name: data.categorySlug
        },
        sub_category: {
            id: data.subCategoryId,
            name: data.subCategorySlug
        }
    };

    sendMixPanelEvent({eventName: CLICKED_POPULAR_SEARCH_TAG, params: mpParams});
    sendBigQueryEvent({eventName: BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG, params: bqParams});
};

const reportSearchBi = (data) => {
    sendMixPanelEvent({eventName: CLICKED_BANNER_SEARCH, params: data});
};

export const reportBi = (type, data) => {
    switch (type) {
        case BI_TYPE_TAGS:
            reportTagBi(data);
            break;
        case BI_TYPE_SEARCH:
            reportSearchBi(data);
            break;
        default:
            break;
    }
};

/*
    Please note when you add other tags - 2 tag types
    'subcategory'
    'search_term'
*/

const voiceOver = {
    name: 'Voice Over',
    type: 'subcategory',
    categoryId: 12,
    categorySlug: 'music-audio',
    subCategoryId: 16,
    subCategorySlug: 'voice-overs'
};

const translation = {
    name: 'Translation',
    type: 'subcategory',
    categoryId: 2,
    categorySlug: 'online-marketing',
    subCategoryId: 108,
    subCategorySlug: 'quality-translation-services'
};

const logoDesign = {
    name: 'Logo Design',
    type: 'subcategory',
    categoryId: 3,
    categorySlug: 'graphics-design',
    subCategoryId: 49,
    subCategorySlug: 'creative-logo-design'
};

const articlesBlogPosts = {
    name: 'Articles & Blog Posts',
    type: 'subcategory',
    categoryId: 5,
    categorySlug: 'writing-translation',
    subCategoryId: 163,
    subCategorySlug: 'articles-blogposts'
};

export const popularSearches = [
    voiceOver,
    translation,
    logoDesign,
    articlesBlogPosts
];
